var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3632 8.49756C22.5564 8.49756 27.0682 11.5346 29.3068 14.4215C30.3667 15.7888 30.9148 17.1488 30.9148 18.1772C30.9148 19.2057 30.3667 20.5657 29.3068 21.9329C27.0684 24.8199 22.5564 27.8569 17.3632 27.8569C12.1699 27.8569 7.65811 24.8199 5.41956 21.9329C4.35962 20.5657 3.81152 19.2057 3.81152 18.1772C3.81152 17.1488 4.35962 15.7888 5.41956 14.4215C7.65799 11.5346 12.1699 8.49756 17.3632 8.49756ZM17.3632 12.8533C14.4254 12.8533 12.0392 15.2381 12.0392 18.1772C12.0392 21.1164 14.4252 23.5012 17.3632 23.5012C20.3011 23.5012 22.6871 21.1164 22.6871 18.1772C22.6871 15.2381 20.3011 12.8533 17.3632 12.8533ZM17.3632 14.7892C19.2326 14.7892 20.7512 16.3065 20.7512 18.1772C20.7512 20.048 19.2327 21.5653 17.3632 21.5653C15.4936 21.5653 13.9751 20.048 13.9751 18.1772C13.9751 16.3065 15.4936 14.7892 17.3632 14.7892Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b8eff4dc4facc8b28c0dea5b0c9fa13d.svg";
export { ForwardRef as ReactComponent };